<template>
  <div>
    <h2>{{ isEdit ? 'Modification' : 'Ajout' }} de client</h2>

    <div class="row">
      <div class="mb-3 col-md-6">
        <label for="nom_client" class="form-label fw-bold">Nom*</label>
        <input type="text" class="form-control" id="nom_client" placeholder="Nom du client" v-model="formData.nom"
          required>
          <small class="text-danger" v-if="errors['nom']">{{ errors['nom'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6">
        <label for="prenoms_client" class="form-label">Prénoms</label>
        <input type="text" class="form-control" id="prenoms_client" placeholder="Prénoms du client"
          v-model="formData.prenoms">
          <small class="text-danger" v-if="errors['prenoms']">{{ errors['prenoms'][0] }}</small>
      </div>

      <div class="mb-3 col-md-6">
        <label for="telephone_client" class="form-label fw-bold">Téléphone*</label>
        <input type="text" class="form-control" id="telephone_client" placeholder="Téléphone du client"
          v-model="formData.telephone" required>
          <small class="text-danger" v-if="errors['telephone']">{{ errors['telephone'][0] }}</small>

      </div>

      <div class="mb-3 col-md-6">
        <label for="telephone2_client" class="form-label">Téléphone secondaire</label>
        <input type="text" class="form-control" id="telephone2_client" placeholder="Téléphone du client"
          v-model="formData.telephone2" required>
      </div>
      <div class="mb-3 col-md-6">
        <label for="adresse_client" class="form-label">Adresse</label>
        <input type="text" class="form-control" id="adresse_client" placeholder="Adresse du client"
          v-model="formData.adresse">
      </div>

      <div class="mb-3 col-md-6">
        <label for="genre_client" class="form-label fw-bold">Genre*</label>

        <select class="form-select" v-model="formData.genre" required>
          <option value="" selected disabled>-- Sélectionner le genre --</option>
          <option value="M">Homme</option>
          <option value="F">Femme</option>
        </select>
          <small class="text-danger" v-if="errors['genre']">{{ errors['genre'][0] }}</small>

      </div>


      <div class="row mt-2">
        <div class="col text-end">
          <button class="btn btn-success" @click="save"><i class="bi bi-check-circle me-1"></i>Enregistrer</button>
          <button type="button" class="btn btn-secondary mx-2"
            @click="$router.push({ name: 'clients' })"><i class="bi bi-x-circle me-1"></i>Annuler</button>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '@/mixins/formMixin';

export default {
  name: 'ClientForm',
  mixins: [formMixin],
  data() {
    return {
      defaultData: {
        genre: 'M'
      },
      url: '/clients'
    }
  },
  

}
</script>

<style scoped>
form div {
  margin-bottom: 8px
}
</style>
